import React from 'react';

interface HeroVideoBackgroundProps {
  children: React.ReactNode;
  opacity?: number;
}

export default function HeroVideo() {
  return (    <div className="relative w-full h-[60vh] md:h-[80vh] overflow-hidden bg-black">
      <video
        src="https://ucarecdn.com/dbb41ba4-5f7d-4a9d-b1ea-1e2a76e6af29/Narayanthan.mp4"
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="/images/homestay1.jpg"
      />
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent z-10" />
    </div>
  );
}

export function HeroVideoBackground({ children, opacity = 0.3 }: HeroVideoBackgroundProps) {
  return (
    <div className="relative isolate px-6 pt-14 lg:px-8 overflow-hidden">      {/* Video Background */}
      <div className="absolute inset-0 -z-10">
        <video
          src="https://ucarecdn.com/dbb41ba4-5f7d-4a9d-b1ea-1e2a76e6af29/Narayanthan.mp4"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ opacity }}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster="/images/homestay1.jpg"
        />
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/60" />
      </div>
      
      {/* Existing gradient backgrounds */}
      <div className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80">
        <div className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-primary-400 to-secondary-400 opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" />
      </div>
      
      {/* Content */}
      {children}
      
      <div className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
        <div className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-secondary-400 to-primary-400 opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]" />
      </div>
    </div>
  );
}
